import { render, staticRenderFns } from "./Placeholder.vue?vue&type=template&id=54b6d6e4&"
import script from "./Placeholder.vue?vue&type=script&lang=js&"
export * from "./Placeholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports